// REISOR_PHASE2_DEVICE_QA_THEME_SAFE_NOTICE_V1

function removeExistingNotice() {
  if (typeof document === "undefined") return;

  document
    .querySelectorAll("[data-reisor-theme-safe-notice]")
    .forEach((node) => node.remove());
}

export function showThemeSafeNotice(
  message,
  {
    title = "",
    okLabel = "OK",
    tone = "info",
  } = {}
) {
  if (typeof document === "undefined") {
    return;
  }

  removeExistingNotice();

  const overlay =
    document.createElement("div");

  overlay.className =
    "reisor-theme-notice-overlay";

  overlay.setAttribute(
    "data-reisor-theme-safe-notice",
    "v1"
  );

  overlay.setAttribute(
    "role",
    "presentation"
  );

  const panel =
    document.createElement("div");

  panel.className =
    "reisor-theme-notice-panel";

  panel.setAttribute(
    "role",
    "alertdialog"
  );

  panel.setAttribute(
    "aria-modal",
    "true"
  );

  panel.dataset.tone =
    String(tone || "info");

  if (title) {
    const heading =
      document.createElement("div");

    heading.className =
      "reisor-theme-notice-title";

    heading.textContent =
      String(title);

    panel.appendChild(heading);
  }

  const body =
    document.createElement("div");

  body.className =
    "reisor-theme-notice-message";

  body.textContent =
    String(message ?? "");

  const actions =
    document.createElement("div");

  actions.className =
    "reisor-theme-notice-actions";

  const button =
    document.createElement("button");

  button.type =
    "button";

  button.className =
    "reisor-theme-notice-ok";

  button.textContent =
    String(okLabel || "OK");

  actions.appendChild(button);

  panel.appendChild(body);
  panel.appendChild(actions);
  overlay.appendChild(panel);

  let closed = false;

  function close() {
    if (closed) return;
    closed = true;

    document.removeEventListener(
      "keydown",
      onKey
    );

    overlay.remove();
  }

  function onKey(event) {
    if (
      event.key === "Escape" ||
      event.key === "Enter"
    ) {
      close();
    }
  }

  button.addEventListener(
    "click",
    close
  );

  overlay.addEventListener(
    "click",
    (event) => {
      if (event.target === overlay) {
        close();
      }
    }
  );

  document.addEventListener(
    "keydown",
    onKey
  );

  document.body.appendChild(
    overlay
  );

  window.setTimeout(
    () => button.focus(),
    20
  );
}
